<template>
  <li
    v-show="category.applies.filter(apply => !apply.meta.isHide).length"
    class="category-group__item"
    ref="categoryGroup"
    :class="getCategoryClass()">
    <div class="item__header">
      <div>
        <div class="group-name-default" v-if="!isEditMode">
          <!-- todo: i18n check (no group name) -->
          <p class="group-name">
            <template v-if="categoryName === '__shared__'">{{ $t('dashboard.pageShare.folderTitle') }}</template>
            <template v-else>{{ categoryName || 'NO GROUP NAME' }}</template>
          </p>
          <custom-sort-button
            key="normal-sort"
            columnName="custom"
            :isEditMode="isEditMode"
            :sortColumn="sortColumn"
            :canCustomSort="canCustomSort"
            @onSortOptionChange="onSortOptionChange"/>
        </div>
        <!-- 편집모드: category(group) 이름 변경 -->
        <div class="group-name-modify" v-if="isEditMode">
          <input
            type="text"
            maxlength="50"
            :value="categoryName"
            @input="onCategoryNameChange($event.target.value)">

          <custom-sort-button
            key="edit-sort"
            columnName="custom"
            :isEditMode="isEditMode"
            :sortColumn="sortColumn"
            :canCustomSort="canCustomSort"/>
        </div>
      </div>
      <button class="btn__toggle-slide" @click.stop="$emit('onToggleCategory', category)">
        <i class="icon icon--toggle-slide20"/>
      </button>
    </div>
    <!-- page list -->
    <div :class="`item${categoryIndex}`" class="item__body">
      <table v-show="isShowTable">
        <caption hidden>{{ categoryName }}</caption>
        <colgroup>
          <col width="*">
          <col width="44px" v-if="!isEditMode">
          <col width="50px" v-if="isEditMode">
          <col width="78px" v-else>
          <col width="100px" v-if="!isEditMode">
          <col width="140px" v-else>
          <col :width="$i18n.locale === 'ja' ? '100px' : '90px'">
          <col width="90px" v-if="!isEditMode">
          <col width="110px" v-else>
          <col width="90px" v-if="!isEditMode">
          <col width="110px" v-else>
          <col width="90px" v-if="!isEditMode">
          <col width="70px" v-else>
          <col width="95px" v-if="!isEditMode">
          <col width="40px" v-else>
        </colgroup>
        <thead>
          <tr>
            <th class="align-left data__page">
              <div v-if="isEditMode" class="item__handle--wrap">
                <i class="icon icon--dashboard-chkbox"
                   :class="{on: hasCheckedApplies(category)}"
                   :id="`_${categoryName}`"
                   :value="categoryName"
                   @click="onCheckAllClick(category)"/>
              </div>
              <sort-options
                columnName="pageName"
                :isEditMode="isEditMode"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">{{ $t('common.table.header.page') }}</sort-options>
            </th>
            <th v-if="!isEditMode">
              <span>{{ $t('common.table.header.setting') }}</span>
            </th>
            <th class="align-right">
              <sort-options
                columnName="pvPerMonth"
                :isEditMode="isEditMode"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">{{ currentMonthName }}<br>PV</sort-options>
            </th>
            <th>
              <sort-options
                columnName="meta.uiState"
                :isEditMode="isEditMode"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.analysisStatus')"></span></sort-options>
            </th>
            <th>
              <sort-options
                columnName="meta.trackingCodeChecked"
                :isEditMode="isEditMode"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.trackingCode')"></span></sort-options>
            </th>
            <th>
              <sort-options
                columnName="startDate"
                :isEditMode="isEditMode"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.startDate')"></span></sort-options>
            </th>
            <th>
              <sort-options
                columnName="endDate"
                :isEditMode="isEditMode"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.endDate')"></span></sort-options>
            </th>
            <th class="head-weekly">
              <template v-if="!isWeeklyReportAvailable">
                <span v-html="$t('common.table.header.weeklyReport')"></span>
                <div class="not-support-weekly">
                  <ui-icon-tooltip iconSize="white-size17" arrowCenter>
                    <span v-html="$t('dashboard.notSupportWeeklyReport')"></span>
                  </ui-icon-tooltip>
                </div>
              </template>
              <sort-options
                v-else
                columnName="isSubscribeWeeklyReport"
                :isEditMode="isEditMode"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.weeklyReport')"></span></sort-options>
            </th>
            <th v-if="!isEditMode">
              <span v-html="$t('common.table.header.report')"></span>
            </th>
            <th v-else></th>
          </tr>
        </thead>
      </table>

      <draggable
        tag="table"
        v-show="isShowTable"
        style="table-layout: fixed"
        :list="category.applies"
        :forceFallback="false"
        :disabled="!isEditMode"
        :animation="200"
        filter="input, button"
        :preventOnFilter="false"
        @end="onDragEnd($event)">
        <template v-for="item in category.applies">
          <tbody :key="item.id" class="draggable-wrap">
            <apply-item v-show="!item.meta.isHide"
                        :item="item"
                        :isSharedCategory="category._id === '__shared__'"
                        :isEditMode="isEditMode"
                        :selectedApplies="selectedApplies"
                        :isWeeklyReportAvailable="isWeeklyReportAvailable"
                        :searchKeyword="searchKeyword"
                        @onCheckInstallClick="$emit('onCheckInstallClick', $event)"
                        @onApplyChange="$emit('onApplyChange', $event)"
                        @onApplyMetaChange="$emit('onApplyMetaChange', $event)"
                        @onAllApplyMetaChange="onAllApplyMetaChange"
                        @onToggleSubscribeWeeklyReport="$emit('onToggleSubscribeWeeklyReport', $event)"
                        @onHideSettingOption="$emit('onHideSettingOption')"/>
            <shared-row v-if="item.meta.isShowShareRow && !isEditMode"
                        :applyData="item"
                        :isEditMode="isEditMode"
                        @onApplyChange="$emit('onApplyChange', $event)"
                        @onApplyMetaChange="$emit('onApplyMetaChange', $event)"/>
          </tbody>
        </template>
      </draggable>
    </div>
  </li>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/libs/event-bus'
import draggable from 'vuedraggable'
import ApplyItem from '@/components/dashboard/ApplyItem'
import SharedRow from '@/components/dashboard/SharedRow'
import SortOptions from '@/components/ui/SortOptions'
import CustomSortButton from '@/components/dashboard/CustomSortButton'
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import { utcToLocalTimezone } from '@/libs/utils'

const monthNameKeys = ['jan', 'feb', 'mar', 'apr', 'may', 'june', 'july', 'aug', 'sep', 'oct', 'nov', 'dec']

export default {
  name: 'ApplyCategoryList',
  components: {
    draggable,
    ApplyItem,
    SharedRow,
    SortOptions,
    CustomSortButton,
    UiIconTooltip
  },
  props: [
    'isEditMode',
    'categoryState',
    'category',
    'categoryIndex',
    'selectedApplies',
    'searchKeyword',
    'scrollTop',
    'timezoneName'
  ],
  data () {
    return {
      isShowTable: true,
      currentMonthName: this.$t(`common.month.${monthNameKeys[utcToLocalTimezone(new Date(), this.timezoneName).getMonth()]}`),
      scrollable: true
    }
  },
  watch: {
    isEditMode (value) {
      if (value) {
        // force IE redraw
        this.isShowTable = false
        this.$nextTick().then(() => {
          this.isShowTable = true
        })
      }
    },
    scrollTop (value) {
      const offsetTop = this.$el.offsetTop - 100 // [BEUS-1950] 상단으로부터 100px
      if (this.scrollable && value > offsetTop && value < offsetTop + this.$el.offsetHeight) {
        EventBus.$emit('scrollUpdateCurrentCategoryIndex', this.categoryIndex, this.category._id)
      }
      this.scrollable = true
    },
    timezoneName () {
      this.currentMonthName = this.$t(`common.month.${monthNameKeys[utcToLocalTimezone(new Date(), this.timezoneName).getMonth()]}`)
    }
  },
  computed: {
    ...mapState([
      'planData'
    ]),
    categoryName () {
      return this.category._id
    },
    sortOptions () {
      if (this.categoryState) {
        return this.categoryState.sortOptions
      }
      // must return object
      return {}
    },
    sortColumn () {
      return this.sortOptions.column
    },
    isSortAsc () {
      return this.sortOptions.isAsc
    },
    canCustomSort () {
      for (const apply of this.category.applies) {
        if (apply.customRank === undefined || apply.customRank <= 0) {
          return false
        }
      }
      return true
    },
    isWeeklyReportAvailable () {
      return this.planData.feature.weeklyReport
    }
  },
  created () {
    this.today = new Date()
  },
  mounted () {
    EventBus.$on('updateCurrentCategoryIndex', (index) => {
      this.scrollable = false
      if (index === this.categoryIndex) {
        document.querySelector('.category-group').scrollTop = this.$el.offsetTop - 20
      }
    })
  },
  methods: {
    onCheckAllClick () {
      const hasChecked = this.hasCheckedApplies()

      for (const item of this.category.applies) {
        if (item.deleted) {
          continue
        }
        const meta = item.meta
        const key = 'isChecked'
        const value = !hasChecked
        this.$emit('onApplyMetaChange', { meta, key, value })
      }
    },
    onAllApplyMetaChange (metaKey, keyValue) {
      for (const item of this.category.applies) {
        if (item.deleted) {
          continue
        }
        const meta = item.meta
        const key = metaKey
        const value = keyValue
        this.$emit('onApplyMetaChange', { meta, key, value })
      }
    },
    hasCheckedApplies () {
      return this.category.applies.filter(item => item.meta.isChecked).length
    },
    onCategoryNameChange (name) {
      this.$emit('onCategoryNameChange', this.category, name)
    },
    getSortClass (sortColumn) {
      if (this.categoryState) {
        const sortOptions = this.categoryState.sortOptions

        if (sortOptions && sortOptions.column === sortColumn) {
          return sortOptions.isAsc ? 'asc' : 'desc'
        }
      }
      return null
    },
    getCategoryClass () {
      if (this.categoryState && this.categoryState.isFolded) {
        return 'fold'
      }
      return null
    },
    onSortOptionChange (columnName, isAsc) {
      this.$emit('onSortApplies', this.category, columnName, isAsc)
    },
    onDragEnd (event) {
      if (event.oldIndex === event.newIndex) {
        return
      }
      for (let i = 0; i < this.category.applies.length; i++) {
        const apply = this.category.applies[i]
        const key = 'customRank'
        const value = i + 1
        this.$emit('onApplyChange', { apply, key, value })
      }
      this.$emit('onCustomSort', this.category)
    }
  }
}
</script>

<style lang="scss" scoped>
.category-group__item {
  position: relative;
  border-radius: 14px;
  box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 25px;

  &:not(:first-child) {
    margin-top: 30px;
  }

  &:last-child {
    margin-bottom: 30px;
  }

  .item__header {
    button {
      background-color: #fff;
    }

    .group-name-default,
    .group-name-modify {
      position: relative;
    }

    .group-name-modify {
      input {
        width: 290px;
        height: 38px;
        border-radius: 6px;
        border: solid 1px #bbbbbb;
        background-color: #ffffff;
        box-sizing: border-box;
        padding-left: 12px;
        padding-right: 36px;
        font-size: 14px;
        line-height: 1;
        color: #2f2f2f;
      }
    }

    .group-name {
      display: inline-block;
      font-size: 18px;
      font-weight: 500;
      line-height: 20px;
      color: #2f2f2f;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: calc(100% - 260px)
    }

    .btn__category__move {
      position: absolute;
      top: 16px;
      left: 50%;
      transform: translateX(-50%);
      button {
        position: relative;
        width: 34px;
        height: 34px;
        border-radius: 20px;
        border: solid 1px #bbbbbb;
        background-color: #ffffff;

        &:hover {
          @include hoverStyle;
        }

        &.disabled {
          opacity: 0.25;
          pointer-events: none;
        }

        &.pre {
          transform: rotate(180deg);
          margin-right: 5px;
        }

        .icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    .btn__toggle-slide {
      &:hover {
        @include hoverStyle;
      }
      width: 32px;
      height: 32px;
      padding: 6px;
      background-position: center;
      border-radius: 50%;
      position: absolute;
      top: 20px;
      right: 25px;

      .icon {
        pointer-events: none;
      }
    }
  }

  &.fold {
    .item__body {
      display: none;
    }
    .icon--toggle-slide20 {
      transform: rotate(180deg);
    }

    .custom-sort {
      display: none;
    }
  }

  .item__body {
    margin-top: 20px;
    table {
      font-size: 13px;
      table-layout: fixed;
      width: 100%;
    }

    table thead tr {
      height: 50px;
      background-color: #555555;
      line-height: 1.23;
      color: #ffffff;
      text-align: center;

      th:nth-of-type(1) {
        position: relative;
        &:before {
          content: "";
          display: inline-block;
          width: 15px;
          height: 50px;
          position: absolute;
          top: 0;
          left: -5px;
          background-color: #555;
          border-radius: 5px;
        }
      }
      th:nth-last-of-type(1) {
        position: relative;
        &:after {
          content: "";
          display: inline-block;
          width: 10px;
          height: 50px;
          position: absolute;
          top: 0;
          right: -5px;
          background-color: #555;
          border-radius: 5px;
        }
      }

      .align-left {
        text-align: left;
        padding-left: 10px;
      }

      .align-right {
        text-align: right;
        padding-right: 2px;
      }

      th.head-weekly {
        span {
          vertical-align: middle;
        }

        .not-support-weekly {
          position: relative;
          display: inline-block;
          vertical-align: middle;
          margin-left: 5px;

          .icon--info-white-size17 {
            width: 13px;
            height: 13px;
            background-size: contain;
          }
        }
      }

      span {
        position: relative;
        display: inline-block;
        .icon {
          position: absolute;
          top: 50%;
          right: -19px;
          transform: translateY(-50%);
        }
      }
    }

    table tbody tr {
      height: 80px;
      text-align: center;
      border-top: 1px solid #ebebeb;
      box-sizing: border-box;

      &:nth-of-type(1) {
        border-top: none;
      }

      &:nth-last-of-type(1) {
        border-bottom: 1px solid #ebebeb;
      }

      &:not(.deleted):hover {
        background-color: #f4f4f4;
      }

      &.checked:not(.deleted) {
        border: solid 1px #289eef;
        outline: solid 3px rgba(40, 158, 239, 0.18);
      }

      .align-left {
        text-align: left;
        padding-left: 10px;
        box-sizing: border-box;
      }
      .align-right {
        text-align: right;
        padding-right: 15px;
        box-sizing: border-box;
      }

      .data__page {
        .page-name {
          font-size: 14px;
          font-weight: 600;
          line-height: 1;
          color: #2f2f2f;
          span {
            display: inline-block;
          }
        }
        .page-url {
          margin-top: 14px;
          font-size: 13px;
          line-height: 1;
          color: #666666;
          vertical-align: text-bottom;
          .match-type {
            display: inline-block;
            margin-right: 8px;
            font-size: 12px;
            font-weight: 500;
            line-height: 1.17;
            color: #ffffff;
            padding: 1px 5px;
            border-radius: 4px;
            background-color: #8d8d8d;
          }
          span:not(.match-type) {
            vertical-align: text-bottom;
            display: inline-block;
            width: 140px;
            @include textEllipsis;
          }
        }
      }

      .data__setting .icon {
        &:hover {
          background-color: rgba(0, 0, 0, 0.06);
        }
        border-radius: 50%;
        width: 32px;
        height: 32px;
        background-position: center;
      }

      .data__pv {
        color: #2f2f2f;
      }
      .data__status,
      /deep/ .selected-item span,
      /deep/ .item-name {
        font-weight: 600;
        &.run {
          color: $stateRunColor;
        }
        &.stop {
          color: $stateStopColor;
        }
        &.error {
          color: $stateUnInstalledColor;
        }
        &.uninstalled {
          color: $stateUnInstalledColor;
        }
        &.endByPvLimit {
          color: $stateEndColor;
        }
        &.endByAnalysisDate {
          color: $stateEndColor;
        }
        &.reservation {
          color: $stateReservationColor;
        }
      }

      .data__tracking-code {
        button {
          @include buttonTypeSmall;
          height: 34px;
          line-height: 32px;
          border: solid 1px #bbbbbb;
          background-color: #ffffff;
          min-width: inherit;

          &:hover {
            @include hoverStyle;
          }
        }
      }

      .data__start-date {
        color: #666;
      }

      .data__end-date {
        color: #666;
      }

      .data__weekly-report {
        button {
          position: relative;
          width: 53px;
          height: 25px;
          line-height: 23px;
          border-radius: 12.5px;
          font-size: 12px;
          font-weight: 600;
          box-sizing: border-box;
          background-color: #d7d7d7;
          color: #fff;
          text-align: right;
          padding-right: 7px;

          &.on {
            background-color: #64b950;
            text-align: left;
            padding-left: 7px;

            .circle {
              left: auto;
              right: 3px;
            }
          }

          .circle {
            display: inline-block;
            width: 19px;
            height: 19px;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.18);
            background-color: #ffffff;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 3px;
            transform: translateY(-50%);
          }
        }
      }

      .data__confirm {
        button {
          position: relative;
          width: 75px;
          height: 34px;
          border-radius: 20px;
          border: solid 1px #57ab00;
          background-color: #ffffff;
          box-sizing: border-box;
          text-align: right;
          padding-right: 13px;
          font-weight: 600;
          line-height: 32px;
          color: #4a8500;

          &:hover {
            background-color: rgba(0, 0, 0, 0.06);
          }

          .icon {
            position: absolute;
            top: 50%;
            left: 11px;
            transform: translateY(-50%);
          }
        }
      }

      .data__delete__page {
        .icon {
          width: 32px;
          height: 32px;
          background-position: center;
          border-radius: 100%;
          appearance: none;
          cursor: pointer;

          &:hover {
            @include hoverStyle;
          }
        }
      }
    }
  }
  &.edit-mode {
    &.category-group__item {
      padding-top: 15px;
      .item__body {
        margin-top: 7px;
        table {
          thead tr .align-left {
            padding-left: 60px;
          }

          .data__page {
            position: relative;
            .icon--drag {
              @include positionYcenter;
              left: 8px;
            }

            .item__handle--wrap {
              height: 17px;
              position: absolute;
              top: 17px;
              left: 28px;

              .icon--dashboard-chkbox {
                appearance: none;
                margin: 0;
              }
            }

            .page-name input {
              width: 90%;
              height: 38px;
              border-radius: 6px;
              border: solid 1px #bbbbbb;
              background-color: #ffffff;
              box-sizing: border-box;
              padding-left: 12px;
              padding-right: 12px;
            }

            .page-url {
              margin-top: 6px;
            }
          }
        }
        table tbody tr {
          &:not(.deleted):hover {
            background-color: transparent;
          }
        }
      }
    }
  }

  &.edit-mode {
    .category-group__item {
      padding-top: 15px;
      .item__body {
        margin-top: 7px;
        table {
          thead tr .align-left {
            padding-left: 60px;
          }
        }
      }
    }
  }
}

// todo: style customization
/*.sortable-fallback,*/
/*.sortable-drag,*/
.sortable-chosen {
  border-left: 1px solid #289eef !important;
  background-color: #f4f4f4;
}
.sortable-ghost {
  border: transparent !important;
  opacity: 0;
}
</style>
